import { entries } from "./Map";

// A random string that shouldn't collide with anything else...
const mapFingerprint = "OhC4K6m8lHkizASp3edl";

/**
 * Serialises a JS object into a custom format which preserves Maps.
 */
export const serialise = (data: any) =>
	JSON.stringify(data, (_key: string, value: any): any => {
		if (value instanceof Map) {
			return {
				fingerprint: mapFingerprint,
				entries: entries(value)
			};
		}
		return value;
	});

/**
 * Deserialises a string from a custom serialisation format which preserves Maps.
 */
export const deserialise = (serial: string) =>
	JSON.parse(serial, (_key: string, value: any): any => {
		if (value && typeof value === "object" && value.fingerprint === mapFingerprint) {
			return new Map(value.entries);
		}
		return value;
	});

export const escape = (str: string, char: string, escapeChar: string): string => {
	return str
		.replace(new RegExp(`\\${escapeChar}`, "g"), `${escapeChar}${escapeChar}`)
		.replace(new RegExp(`\\${char}`, "g"), `${escapeChar}${char}`);
};

export const unescape = (str: string, char: string, escapeChar: string): string => {
	return str
		.replace(new RegExp(`\\${escapeChar}\\${char}`, "g"), char)
		.replace(new RegExp(`\\${escapeChar}\\${escapeChar}`, "g"), escapeChar);
};
